import { OrganisationSearchResult } from './organisation-search-result';

export class OrganisationNotFoundResult extends OrganisationSearchResult {
	public constructor() {
		super();
	}
}
